import { Injectable, signal, WritableSignal } from '@angular/core';
import { SessionDataFieldsFragment, SessionDataGQL } from '../graphql/gql';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionDataService {
  
  private sessionDataWritable: WritableSignal<SessionDataFieldsFragment | null> = signal(null)
  sessionData = this.sessionDataWritable.asReadonly()

  constructor(private sessionDataGQL: SessionDataGQL) {}

  async refresh() {
    const sessionData = await lastValueFrom(this.sessionDataGQL.fetch().pipe(
      map(result => result.data.sessionData)
    ))
    this.sessionDataWritable.set(sessionData)
  }
}
